import type { DropdownProps as AntdDropdownProps } from "antd";
import { Dropdown as AntdDropdown } from "antd";
import React from "react";

export interface DropdownProps extends AntdDropdownProps {}
const Dropdown = (props: DropdownProps) => {
  return <AntdDropdown {...props} />;
};

Dropdown.displayName = "Dropdown";

export default Dropdown;
